import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';

import translationEng from './locales/en/translation.json';
import translationNor from './locales/nor/translation.json';

const i18nWrapper = defaultLanguage => {
  i18n
    .use(XHR)
    .use(LanguageDetector)
    .init({
      debug: process.env.NODE_ENV !== 'production',
      lng: defaultLanguage || 'English',
      fallbackLng: defaultLanguage || 'English',
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ','
      },
      react: {
        wait: true,
        useSuspense: false
      },

      ns: ['translations'],
      defaultNS: 'translations',

      resources: {
        English: {
          translations: translationEng
        },
        Norway: {
          translations: translationNor
        }
      }
    });

  return i18n;
};

export default i18nWrapper;
